/**
 * rack-card-gallery.js
 *
 * HOMEPAGE CARDS: Syncs the hover (back) image on product cards when a color swatch changes.
 *   - Slide 1,3,5,7 = front images (have variant-image attr, theme controls visibility via hidden)
 *   - Slide 2,4,6,8 = back images  (no variant-image attr, theme never touches these)
 *   - CSS crossfade targets nth-child(1) and nth-child(2), so slide 2 must mirror the active color's back.
 *
 * PRODUCT PAGE: Filters the media grid so only the selected color's front + back images are shown.
 *   - Apliiq images share a numeric filename prefix per color (e.g. "5940233_5134" and "5940233_5136").
 *   - The active front LI is marked with data-view-transition-type="product-image-transition".
 *   - All LIs whose filename prefix differs from the active front are force-hidden via inline style.
 */
(function () {
  'use strict';

  /* ============================================================
   * HOMEPAGE: sync hover back image when color swatch changes
   * ============================================================ */

  function syncCardBackImage(productCard) {
    var slideshow = productCard.refs && productCard.refs.slideshow;
    if (!slideshow) return;

    var slides = (slideshow.refs && slideshow.refs.slides) || [];
    if (slides.length < 3) return;

    var slide2 = slides[1];
    if (!slide2) return;

    var activeFrontIdx = 0;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].hasAttribute('variant-image') && !slides[i].hidden) {
        activeFrontIdx = i;
        break;
      }
    }

    var backIdx = activeFrontIdx + 1;
    if (backIdx === 1) return; // color 1 already in slide 2

    var backSlide = slides[backIdx];
    if (!backSlide) return;

    var srcImg = backSlide.querySelector('img');
    var dstImg = slide2.querySelector('img');
    if (!srcImg || !dstImg) return;

    if (srcImg.src !== dstImg.src) {
      dstImg.src = srcImg.src;
      dstImg.srcset = srcImg.srcset || '';
      dstImg.alt = srcImg.alt || '';
    }
  }

  function setupCard(productCard) {
    var slideshow = productCard.refs && productCard.refs.slideshow;
    if (!slideshow) return;

    var slides = (slideshow.refs && slideshow.refs.slides) || [];
    if (slides.length < 3) return;

    var observer = new MutationObserver(function () {
      syncCardBackImage(productCard);
    });

    for (var i = 0; i < slides.length; i++) {
      if (slides[i].hasAttribute('variant-image')) {
        observer.observe(slides[i], { attributes: true, attributeFilter: ['hidden'] });
      }
    }
  }

  function initHomepage() {
    var list = document.querySelector('[id$="product_list_themegen"]');
    if (!list) return;

    var cards = list.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var pc = cards[i];
      if (pc.refs && pc.refs.slideshow) {
        setupCard(pc);
      } else {
        (function (card) {
          setTimeout(function () { setupCard(card); }, 400);
        })(pc);
      }
    }
  }

  /* ============================================================
   * PRODUCT PAGE: filter grid to only show current color's images
   * ============================================================ */

  function getFilePrefix(url) {
    // e.g. "https://cdn.../5940233_5134_590_900.jpg?v=..." -> "5940233"
    var file = (url || '').split('?')[0].split('/').pop();
    return file.split('_')[0];
  }

  function syncProductPageImages() {
    // The active front image LI is always marked with this attribute by the Feather theme
    var frontLI = document.querySelector(
      'li.product-media-container[data-view-transition-type="product-image-transition"]'
    );
    if (!frontLI) return;

    var gridParent = frontLI.closest('ul');
    if (!gridParent) return;

    var frontImg = frontLI.querySelector('img');
    if (!frontImg) return;

    var frontPrefix = getFilePrefix(frontImg.currentSrc || frontImg.src || '');
    if (!frontPrefix || frontPrefix.length < 4) return; // sanity check

    Array.from(document.querySelectorAll('li.product-media-container')).forEach(function (li) {
      var img = li.querySelector('img');
      if (!img) return;
      var prefix = getFilePrefix(img.currentSrc || img.src || '');

      if (prefix !== frontPrefix) {
        // Wrong color — force-hide (inline !important overrides theme's display:flex rule)
        li.style.setProperty('display', 'none', 'important');
      } else {
        // Correct color — ensure visible
        li.style.removeProperty('display');
      }
    });
  }

  function initProductPage() {
    if (!document.querySelector('main[data-template="product"]')) return;

    // Run on initial load with retries to handle deferred rendering
    setTimeout(syncProductPageImages, 150);
    setTimeout(syncProductPageImages, 500);
    setTimeout(syncProductPageImages, 1200);

    // Watch for variant changes: the theme updates the front LI's img src or
    // swaps which LI carries the data-view-transition-type attribute
    var main = document.querySelector('main[data-template="product"]');
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return (
          (m.type === 'attributes' &&
            (m.attributeName === 'src' ||
              m.attributeName === 'srcset' ||
              m.attributeName === 'data-view-transition-type')) ||
          m.type === 'childList'
        );
      });
      if (relevant) {
        setTimeout(syncProductPageImages, 80);
        setTimeout(syncProductPageImages, 350);
      }
    });

    observer.observe(main, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-view-transition-type']
    });
  }

  /* ============================================================
   * INIT
   * ============================================================ */

  function init() {
    initHomepage();
    initProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
